import type { UserGroupBase } from '../userGroups.types';

export class UserGroupBaseModel {
  private readonly _dto: UserGroupBase;

  constructor(dto?: UserGroupBase) {
    this._dto = dto ?? {};
  }

  get originDTO(): UserGroupBase {
    return this._dto;
  }

  get description(): string {
    return this._dto.description || '';
  }

  get name(): string {
    return this._dto.name || '';
  }

  get tenantId(): string {
    return this._dto.tenantId || '';
  }

  get userGroupId(): string {
    return this._dto.userGroupId || '';
  }
}
